import styled from 'styled-components';

export const BotaoAvaliar = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  overflow: hidden;
  position: relative;

  &:hover {
    transform: scale(1.1);
  }
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const IconWrapper = styled.div<{ $opacity: 0 | 0.5 | 1 }>`
  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 50%;
    width: ${({ $opacity }) => ($opacity === 0.5 ? '100%' : '0%')};
    height: 100%;
    background-color: rgba(25, 25, 25, 0.5);
    pointer-events: none;
  }
`;
